export default __webpack_public_path__ + "static/media/house4.287c75d7.jpg";